'use strict'

/**
 * @param {function} fetch
 * @param {string} url
 * @param {object} data
 * @param {Element} $insertBeforeElement
 * @returns {Promise}
 */
export function loadHtmlContentBeforeElement(fetch, url, data, $insertBeforeElement) {
    return fetch(`${url}?${encodeToUri(data)}`)
        .then(response => response.json())
        .then(json => {
            $(json.data).insertBefore($insertBeforeElement)

            return json
        })
}

function encodeToUri(params) {
    return Object.keys(params).map(key => `${key}=${params[key]}`).join('&')
}


// WEBPACK FOOTER //
// ./app/Resources/assets/js/lib/loadHtmlContentBeforeElement.js